import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, apiErr } from "@/lib/api";

export default function ResetPassword() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const token = sp.get("token") || "";
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) return toast.error("Password must be at least 6 characters");
    setBusy(true);
    try { await api.post("/auth/reset-password", { token, password: pw }); toast.success("Password updated! Please log in."); nav("/login"); }
    catch (er) { toast.error(apiErr(er)); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-emerald-50 px-4">
      <div className="w-full max-w-md bg-white rounded-3xl shadow-xl p-8 animate-fade-up">
        <Link to="/" className="flex items-center gap-2 justify-center mb-6"><div className="w-10 h-10 bg-emerald-600 rounded-xl flex items-center justify-center text-white font-extrabold text-lg">₹</div><span className="font-extrabold text-xl">Rani Super Market</span></Link>
        <h1 className="text-2xl font-bold text-center">Set new password</h1>
        {!token ? (
          <p className="text-center text-red-500 text-sm mt-3">Invalid reset link. <Link to="/forgot-password" className="text-emerald-600 font-bold">Request a new one</Link></p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-3">
            <input data-testid="reset-password" type="password" placeholder="New password" value={pw} onChange={(e) => setPw(e.target.value)} required className="w-full border border-slate-200 rounded-xl px-4 py-3 text-sm" />
            <button data-testid="reset-submit" disabled={busy} className="w-full py-3 bg-emerald-600 hover:bg-emerald-700 disabled:opacity-60 text-white rounded-xl font-bold transition-colors">{busy ? "Updating…" : "Update password"}</button>
          </form>
        )}
        <p className="text-center text-sm text-slate-500 mt-5"><Link to="/login" className="text-emerald-600 font-bold">Back to sign in</Link></p>
      </div>
    </div>
  );
}
